// extracted by mini-css-extract-plugin
export default {"root":"FinishedImage_root__W31zN","close":"FinishedImage_close__T4+su","image":"FinishedImage_image__W8NeJ"};